export default __webpack_public_path__ + "static/media/25.bb758885.jpg";